<template>
  <div
    class="hero pt-18.5 max-xl:pt-10.5"
    :class="[`hero--${variant}`, ui?.root]"
  >
    <UContainer>
      <nav
        v-if="slots?.breadcrumbs"
        class="breadcrumbs"
        :class="ui?.breadcrumbs"
        aria-label="Хлебные крошки"
      >
        <slot name="breadcrumbs" />
      </nav>

      <component
        :is="variant === 'directions' ? 'div' : 'h1'"
        class="title"
        :class="ui?.title"
      >
        <slot v-if="hero || slots['title']" name="title">
          <template v-if="hero">{{ hero.title }}</template>
        </slot>
      </component>

      <p class="description mt-h1-paragraph" :class="ui?.description">
        <slot v-if="hero || slots['description']" name="description">
          <template v-if="hero">{{ hero.description }}</template>
        </slot>
      </p>

      <slot v-if="variant !== 'directions'" name="search">
        <SPHeroSearch
          class="mt-14 xl:max-w-1/2 max-xl:max-w-6/8 max-lg:max-w-full max-xl:mb-10 max-md:max-w-full md:mt-8"
          @search="emit('search', $event)"
        />
      </slot>

      <slot v-if="variant !== 'directions'" name="directions">
        <SPDirections :class="ui?.directions" data-slot="directions">
          <template #all-button>
            <UButton
              class="block py-2.75 px-4 w-max min-w-44 mb-6 ml-auto max-xl:hidden text-button-secondary-foreground! bg-white! opacity-100 outline-0"
              color="neutral"
              variant="soft"
              trailing-icon="i-local-move-up-right"
              to="/directions"
              :ui="{
                trailingIcon: 'w-4 h-4 align-middle',
              }"
            >
              Все направления
            </UButton>
          </template>
        </SPDirections>
      </slot>
    </UContainer>
  </div>
</template>

<script lang="ts" setup>
import type { PageVariant } from '~/types'

defineOptions({
  name: 'SPHero',
})

const route = useRoute()
const hero = route.meta.hero

const emit = defineEmits<{
  search: [value: string]
}>()

withDefaults(
  defineProps<{
    variant?: PageVariant
    ui?: {
      root?: string
      title?: string
      description?: string
      breadcrumbs?: string
      directions?: string
    }
  }>(),
  {
    variant: 'main',
    ui: () => ({}),
  },
)

defineSlots<{
  breadcrumbs: () => any
  title: () => any
  description: () => any
  search: () => any
  directions: () => any
}>()

const slots = useSlots()
</script>

<style lang="scss" scoped>
.hero {
  &--directions {
    padding-top: 30px;
    padding-bottom: 72px;
  }
}

.hero__container--directions {
  max-width: 580px;
  margin-left: 40px;
  margin-right: 0;
}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 40px;
}

.title {
  font-size: var(--text-size-h1);
  line-height: var(--text-line-height-h1);
  font-weight: 600;
  color: var(--color-white);

  @include isLessThan(md) {
    line-height: 42px;
  }

  .hero--directions & {
    font-size: var(--text-size-h2);
    line-height: 40px;
    letter-spacing: -0.12px;
  }
}

.description {
  font-size: var(--text-size-h5);
  line-height: 28px;
  font-weight: 500;
  max-width: 45%;
  margin-top: var(--spacing-h1-paragraph);
  color: var(--color-white);

  .hero--directions & {
    max-width: 400px;
    margin-top: 16px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
  }

  @include isLessThan('md') {
    max-width: 100%;
  }
}
</style>
